<template>
  <div id="feedKitchen">
    <h5>
      <img alt="" src="@/assets/images/babyFeeding/xiachufang.png">
      <img alt="" src="@/assets/images/babyFeeding/more.png" @click="handleBack">
    </h5>
    <div class="kitchen-list">
      <div v-for="item in recipesListInfs" :key="item.id" class="list-data">
        <div :data="JSON.stringify(dataInfo(item))" class="list-item"
             @click="handleKitchen(item)">
          <div v-lazy:background-image="item.bigImgUrl" class="item-imgs">
            <!--          <img alt="" class="imgs-bg" src="@/assets/images/babyFeeding/spbof.png">-->
            <img alt="" class="imgs-posit" src="@/assets/images/babyFeeding/spbof.png">
          </div>
          <div class="item-text">
            <p>{{ item.title }}</p>
            <p class="label">
              <van-button v-for="tag in setTagItem(item.tag)" :key="tag" color="#EA872C" plain>{{ tag }}</van-button>
              <!-- <span v-for="ds in setTagItem(item.tag)" :key="ds">
                <i>{{ ds }}</i>
              </span> -->
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {Exposurer_babyFeed_Fn,} from "@assets/js/BuriedPointEvent";

export default {
  name: "feedKitchen",
  props: {
    recipesList: Array,
    currentId: Number
  },
  data() {
    return {
      babyFeedYue: {},
    }
  },
  created() {
    this.babyFeedYue = JSON.parse(localStorage.getItem("babyFeedYue")) || {};
  },
  computed: {
    recipesListInfs: function () {
      return this.recipesList
      // if (this.recipesList.length <= 2) {
      //   return this.recipesList
      // } else {
      //   const arr = []
      //   for (let i = 0; i < 4; i++) {
      //     const ls = Math.floor(Math.random() * this.recipesList.length)
      //     arr.push(this.recipesList[ls])
      //   }
      //   return arr
      // }
    }
  },
  mounted() {
    Exposurer_babyFeed_Fn.observe("xmhh5_bbsp_view", ".list-item", false);
  },
  methods: {
    dataInfo(item) {
      return {
        xmhh5_bbsp_title: item.oldTitle ? item.oldTitle : item.title,
        xmhh5_bbsp_viewstation: this.$route.meta.xmhh5_bbsp_viewstation,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name,
      };
    },
    handleBack() {
      this.$router.push({path: "/recipeSearchList/" + this.$props.currentId})
      // if (window.history.length > 1) {
      //   this.$router.go(-1)
      // } else {
      //   this.$router.replace("/recipeSearchList")
      // }
    },
    handleKitchen(item) {
      this.$emit("handleKitchen", item)
    },
    setTagItem(str) {
      if (str && str != "") {
        const arr = str.split(',')
        return arr.filter((item, index) => index < 2)
      }
      return []
    },
  }
}
</script>

<style lang="less" scoped>
#feedKitchen {
  h5 {
    margin-top: 19px;
    height: 16px;
    display: flex;
    justify-content: space-between;

    img {
      &:first-child {
        width: 112px;
        height: 16px;
      }

      &:last-child {
        width: 30px;
        // height: 16px;
      }
    }
  }

  .kitchen-list {
    width: 100%;
    display: flex;
    margin-top: 12px;
    flex-wrap: wrap;
    justify-content: space-between;

    .list-data {
      //margin-left: 6px;
      border-radius: 4px;
      margin-bottom: 8px;

      //&:nth-child(1), &:nth-child(3) {
      //  margin-left: 0;
      //}
    }

    .list-item {
      background: #fff;
      border-radius: 4px;
      flex-shrink: 0;
      width: 172px;
      height: 148px;
      overflow: hidden;

      .item-imgs {
        height: 98px;
        width: 100%;
        border-radius: 4px 4px 0 0;
        position: relative;
        background-size: 100% 100%;

        .imgs-posit {
          position: absolute;
          width: 22px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .item-text {
        overflow: hidden;
        padding: 5px 0 0 6px;
        //margin: 4px auto;
        p {
          &:first-child {
            width: 166px;
            // margin: 4px auto;
            font-size: 12px;
            font-weight: 500;
            color: #333333;
            overflow: hidden; //溢出内容隐藏
            text-overflow: ellipsis; //文本溢出部分用省略号表示
            display: -webkit-box; //特别显示模式
            -webkit-line-clamp: 1; //行数
            line-clamp: 1;
            -webkit-box-orient: vertical; //盒子中内容竖直排列
          }
        }

        .label {
          overflow: hidden; //溢出内容隐藏
          //text-overflow: ellipsis;
          margin-top: 1px;
          white-space: nowrap;

          /deep/ .van-button {
            display: inline-block;
            border-radius: 4px;
            border-color: rgba(250, 222, 91, 0.6) !important;
            font-size: 10px;
            font-weight: 400;
            margin-left: 6px;
            padding: 0 2px;
            height: 16px;

            span {
              margin-top: 2px;
            }

            &:first-child {
              margin-left: 0;
            }

            //&:nth-child(n+1) {
            //  margin-left: 4px;
            //}
          }
        }
      }
    }
  }

  .kitchen-list::-webkit-scrollbar {
    width: 0;
    display: none
  }
}
</style>